import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import isArrayLike from 'lodash/isArrayLike';
import isObject from 'lodash/isObject';
import isEqual from 'lodash/isEqual';

export default {
  methods: {
    shouldApplyDefault(value, defaultValue) {
      if (isUndefined(defaultValue)
        || isEqual(value, defaultValue)
      ) {
        return false;
      }

      return isUndefined(value)
        || (isArrayLike(value) && isEmpty(value))
        || (isObject(value) && isEmpty(value));
    },
  },
};
